
import { Link } from 'react-router-dom'
import './ConfirmationInfo.css'
import ConfirmationInfoCFS from './ConfirmationInfoCFS'
import ConfirmationInfoBrokerage from './ConfirmationInfoBrokerage'
import ConfirmationInfoCES from './ConfirmationInfoCES'
import ConfirmationInfoGO from './ConfirmationInfoGO'
import ConfirmationInfoOEW from './ConfirmationInfoOEW'

function ConfirmationInfo(props) {
 console.log('payment response', props.confirmationData);

  return (
    <>
      <table className='table' border='0'>
        <tbody>
          <tr>
            <td className='td-information-text'>
              <span className='title-text'>Customer Information: </span>{' '}
              <br></br>
              <span className='info-text'>
                {props.confirmationData?.customer.customerContactFirstName}{' '}
                {props.confirmationData?.customer.customerContactLastName}{' '}
                <br></br>
              </span>
            </td>
          </tr>

          
{(props.confirmationData.isBrokerage && <ConfirmationInfoBrokerage 
          confirmationData={props.confirmationData}
                    /> )}

           {(props.confirmationData?.systemOrderType === "CMSSystem" || props.confirmationData.isCFSOrderAssociated) &&  <ConfirmationInfoCFS
          confirmationData={props.confirmationData}

          /> }
           {(props.confirmationData?.systemOrderType === "CESSystem") &&  <ConfirmationInfoCES
          confirmationData={props.confirmationData}

          /> }          
           {(props.confirmationData?.systemOrderType === "GOSystem") &&  <ConfirmationInfoGO
          confirmationData={props.confirmationData}

          /> }
          {(props.confirmationData?.systemOrderType === "OEWSystem") &&  <ConfirmationInfoOEW
          confirmationData={props.confirmationData}

          /> }

          <tr>
            <td className='td-title-text'>
              <span className='title-text'>Commodity: </span>
              <span className='info-text'>
                {props.confirmationData?.cargoDescription}
              </span>
            </td>
          </tr>


          {props.confirmationData.shieldCertificateData ? (

          <tr>
            <td className='td-title-text'>
              <span className='title-text'>Shield Insurance: </span>
              <span className='info-text'>Please use this link to view your 
              <Link target={'_blank'} to= {props.confirmationData.shieldCertificateData?.certificateURL}> Shield Certificate</Link> .
             
              </span>
            </td>
          </tr>
          ) : null}
        </tbody>
      </table>
    </>
  )
}

export default ConfirmationInfo
